'use client';

import { c as _c } from "react/compiler-runtime";
import { motion } from 'framer-motion';
import { ArrowRight, Sparkles } from 'lucide-react';
import Link from 'next/link';
import FloatingLines from '@/components/FloatingLines';
export function HeroSection() {
  const $ = _c(24);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute inset-0 z-0"><FloatingLines enabledWaves={["top", "middle", "bottom"]} lineCount={[10, 15, 20]} lineDistance={[8, 6, 4]} bendRadius={5} bendStrength={-0.5} interactive={true} parallax={true} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 0,
      y: 20
    };
    t2 = {
      opacity: 1,
      y: 0
    };
    t3 = {
      duration: 0.6
    };
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      opacity: 0,
      scale: 0.9
    };
    t5 = {
      opacity: 1,
      scale: 1
    };
    t6 = {
      delay: 0.2
    };
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <motion.div initial={t4} animate={t5} transition={t6} className="inline-flex items-center px-4 py-2 rounded-full bg-primary/10 border border-primary/20 mb-6"><Sparkles className="w-4 h-4 mr-2 text-primary" /><span className="text-sm font-medium text-primary">Premium Knowledge Hub</span></motion.div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t10;
  let t8;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      opacity: 0,
      y: 20
    };
    t9 = {
      opacity: 1,
      y: 0
    };
    t10 = {
      delay: 0.3
    };
    $[8] = t10;
    $[9] = t8;
    $[10] = t9;
  } else {
    t10 = $[8];
    t8 = $[9];
    t9 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <motion.h1 initial={t8} animate={t9} transition={t10} className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight"><span className="gradient-text-primary">Premium Insights</span><br />for Modern Professionals</motion.h1>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  let t13;
  let t14;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      opacity: 0,
      y: 20
    };
    t13 = {
      opacity: 1,
      y: 0
    };
    t14 = {
      delay: 0.4
    };
    $[12] = t12;
    $[13] = t13;
    $[14] = t14;
  } else {
    t12 = $[12];
    t13 = $[13];
    t14 = $[14];
  }
  let t15;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <motion.p initial={t12} animate={t13} transition={t14} className="text-lg md:text-xl text-muted-foreground mb-8 max-w-2xl mx-auto leading-relaxed">Explore research-backed articles on web development, design, technology, lifestyle, and business.<span className="text-foreground font-medium"> Expert knowledge, practical insights.</span></motion.p>;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  let t17;
  let t18;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      opacity: 0,
      y: 20
    };
    t17 = {
      opacity: 1,
      y: 0
    };
    t18 = {
      delay: 0.5
    };
    $[16] = t16;
    $[17] = t17;
    $[18] = t18;
  } else {
    t16 = $[16];
    t17 = $[17];
    t18 = $[18];
  }
  let t19;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <motion.div initial={t16} animate={t17} transition={t18} className="flex flex-col sm:flex-row items-center justify-center gap-4"><Link href="/blog" className="group inline-flex items-center px-8 py-4 rounded-xl bg-primary text-primary-foreground font-semibold hover:bg-primary/90 transition-all duration-200 shadow-lg hover:shadow-xl">Explore Articles<ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" /></Link><Link href="/newsletter" className="inline-flex items-center px-8 py-4 rounded-xl bg-background border-2 border-gray-200 dark:border-gray-800 font-semibold hover:bg-muted transition-all duration-200">Subscribe to Newsletter</Link></motion.div>;
    $[19] = t19;
  } else {
    t19 = $[19];
  }
  let t20;
  let t21;
  let t22;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = {
      opacity: 0,
      y: 20
    };
    t21 = {
      opacity: 1,
      y: 0
    };
    t22 = {
      delay: 0.6
    };
    $[20] = t20;
    $[21] = t21;
    $[22] = t22;
  } else {
    t20 = $[20];
    t21 = $[21];
    t22 = $[22];
  }
  let t23;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <section className="relative overflow-hidden bg-background py-20 md:py-32">{t0}<div className="container relative z-10"><motion.div initial={t1} animate={t2} transition={t3} className="max-w-4xl mx-auto text-center">{t7}{t11}{t15}{t19}<motion.div initial={t20} animate={t21} transition={t22} className="grid grid-cols-3 gap-8 mt-16 max-w-2xl mx-auto"><div><div className="text-3xl md:text-4xl font-bold gradient-text-primary"> 10 </div><div className="text-sm text-muted-foreground mt-1">Articles Every Week</div></div><div><div className="text-3xl md:text-4xl font-bold gradient-text-primary">5</div><div className="text-sm text-muted-foreground mt-1">Categories</div></div><div><div className="text-3xl md:text-4xl font-bold gradient-text-primary">2.0k+</div><div className="text-sm text-muted-foreground mt-1">Avg Words</div></div></motion.div></motion.div></div></section>;
    $[23] = t23;
  } else {
    t23 = $[23];
  }
  return t23;
}